export const NODE_NAMES = {
  BRAND: 'SS_BRAND_SETUP',
  FAMILY: 'PFL_PRODUCT_FAMILY',
  LINE: 'PRL_PRODUCT_LINE',
  PRODUCT: 'PRT_PART',
  NODE_NEUTRAL: 'Neutral',
  NODE_HOVERED: 'Hovered',
  NODE_SELECTED: 'Selected',
};

export const ARIA_LABELS = {
  GROUP_ICON: 'group-icon',
  SEARCH_MODAL_BUTTON: 'search-modal-button',
  SEARCH_MODAL_ICON: 'search-modal-icon',
};

export const HIERARCHY_COLORS = {
  BRAND: '#FFCCCC',
  FAMILY: '#CCFFD4',
  LINE: '#FFEDB2',
  PRODUCT: '#B9D1FA',
};

export const NODE_MARGIN = 20;
